import { DataTypes } from "../types";

export const isBasicInvoiceOption = (dataTypes: string[]) =>
  dataTypes.includes(DataTypes.Invoices) && !dataTypes.includes(DataTypes.InvoiceItems);

export const isDetailedInvoiceOption = (dataTypes: string[]) =>
  dataTypes.includes(DataTypes.Invoices) && dataTypes.includes(DataTypes.InvoiceItems);

export const isAnyInvoiceOption = (dataTypes: string[]) =>
  dataTypes.includes(DataTypes.Invoices) || dataTypes.includes(DataTypes.InvoiceItems);